const NOTIFICATION_ROUTES = {
	admin: {
		'new-claim': (type_id) => `/v2/admin-claims/detail/${type_id}`,
		'new-order': (type_id, pharmacy) => `/v2/tracking/detail/${pharmacy}/${type_id}`,
		'new-quotation': (type_id, pharmacy, id) => `/admin-quotation/detail/${type_id}`,
		'new-preorder': (type_id) => `/preorder/detail/${type_id}`,
		'new-recipe': (type_id, pharmacy) => `/v2/tracking/detail/${pharmacy}/${type_id}`,
	},
	user: {
		'new-claim': (type_id) => `/v2/claims/detail/${type_id}`,
		'new-order': (type_id, pharmacy) => `/v2/tracking/detail/${pharmacy}/${type_id}`,
		'new-quotation': (type_id, pharmacy, id) => `/quotation/detail/${type_id}`,
		'new-preorder': (type_id) => `/preorder/detail/${type_id}`,
		'new-recipe': (type_id, pharmacy) => `/v2/tracking/detail/${pharmacy}/${type_id}`,
	},
};

export const checkNotificationType = ({ notificationType, isAdmin, pharmacy, type_id, id }) => {
	const userType = isAdmin ? 'admin' : 'user';
	const routeBuilder = NOTIFICATION_ROUTES[userType]?.[notificationType];

	if (!routeBuilder) {
		throw new Error(`Invalid notification type or user role: ${notificationType}, ${userType}`);
	}

	return routeBuilder(type_id, pharmacy, id);
};
